import styled from "styled-components";

export const CmpRadioListInfo = styled.div`
  .list-scores-container {
    .score-item {
      margin-bottom: 20px;
    }
  }
  .grade-group-text {
    font-size: 17px;
    font-family: "Nunito Sans";
    color: var(--blue-color);
    margin: 20px 0;
    text-align: center;
  } 
`;

